import React, { Component } from "react";
import Icon1 from "../../images/icon1.svg";
import Icon2 from "../../images/icon2.svg";
import Icon3 from "../../images/icon3.svg";
import {
  ProjectsBox,
  ProjectsH1,
  ProjectsWrap,
  ProjectCard,
  ProjectIcon,
  ProjectH2,
  ProjectP,
} from "./atoms";

class Projects extends Component {
  render() {
    return (
      <>
        <ProjectsBox id="projects">
          <ProjectsH1>My Projects</ProjectsH1>
          <ProjectsWrap>
            <ProjectCard href="https://suspicious-liskov-d87c23.netlify.app/">
              <ProjectIcon src={Icon1} />
              <ProjectH2>Simon Game</ProjectH2>
              <ProjectP>
                My personal implementation of the Simon Memory Skill game
              </ProjectP>
            </ProjectCard>
            <ProjectCard href="https://nickel.netlify.app">
              <ProjectIcon src={Icon2} />
              <ProjectH2>Nickel Eco-Shopping</ProjectH2>
              <ProjectP>
                A web app to show enviromental impact of your shopping list
              </ProjectP>
            </ProjectCard>
            <ProjectCard href="https://github.com/ClintonProjects/Globetrotter#globetrotter">
              <ProjectIcon src={Icon3} />
              <ProjectH2>Globetrotter Point</ProjectH2>
              <ProjectP>
                An interactive map that highlights countries visited around the
                globe
              </ProjectP>
            </ProjectCard>
          </ProjectsWrap>
        </ProjectsBox>
      </>
    );
  }
}

export default Projects;
